// bigNumberPlugin.js
import BigNumber from 'bignumber.js';

const bigNumberPlugin = {
    install(app, options = {}) {
        // Basic arithmetic operations
        // 安全转换为BigNumber并处理小数位
        const safeBigNumber = (value, decimalPlaces) => {
            try {
                let bn = new BigNumber(value);
                if (decimalPlaces !== undefined) {
                    return bn.toFixed(decimalPlaces, BigNumber.ROUND_HALF_UP);
                }
                return bn.toString();
            } catch (e) {
                // 返回带小数位的0
                return decimalPlaces !== undefined ?
                    new BigNumber(0).toFixed(decimalPlaces, BigNumber.ROUND_HALF_UP) :
                    "0";
            }
        };

        // 加法：返回两个大数相加的结果字符串
        const add = (a, b, decimalPlaces) => {
            try {
                const bnA = new BigNumber(a || 0);
                const bnB = new BigNumber(b || 0);
                return bnA.plus(bnB).toFixed(decimalPlaces, BigNumber.ROUND_HALF_UP);
            } catch (e) {
                return safeBigNumber(0, decimalPlaces);
            }
        };

        // 减法：返回两个大数相减的结果字符串
        const subtract = (a, b, decimalPlaces) => {
            try {
                const bnA = new BigNumber(a || 0);
                const bnB = new BigNumber(b || 0);
                return bnA.minus(bnB).toFixed(decimalPlaces, BigNumber.ROUND_HALF_UP);
            } catch (e) {
                return safeBigNumber(0, decimalPlaces);
            }
        };

        // 乘法：返回两个大数相乘的结果字符串
        const multiply = (a, b, decimalPlaces) => {
            try {
                const bnA = new BigNumber(a || 0);
                const bnB = new BigNumber(b || 0);
                return bnA.multipliedBy(bnB).toFixed(decimalPlaces, BigNumber.ROUND_HALF_UP);
            } catch (e) {
                return safeBigNumber(0, decimalPlaces);
            }
        };

        // 除法：返回两个大数相除的结果字符串
        const divide = (a, b, decimalPlaces) => {
            try {
                const bnA = new BigNumber(a || 0);
                const bnB = new BigNumber(b || 0);

                if (bnB.isZero()) {
                    return safeBigNumber(0, decimalPlaces);
                }

                return bnA.dividedBy(bnB).toFixed(decimalPlaces, BigNumber.ROUND_HALF_UP);
            } catch (e) {
                return safeBigNumber(0, decimalPlaces);
            }
        };

        // 比较运算（不需要小数位参数）
        const isGreaterThan = (a, b) => new BigNumber(a || 0).isGreaterThan(b || 0);
        const isLessThan = (a, b) => new BigNumber(a || 0).isLessThan(b || 0);
        const isEqualTo = (a, b) => new BigNumber(a || 0).isEqualTo(b || 0);

        // Comparison operations

        // Formatting
        const format = (value, decimalPlaces = 2) =>
            new BigNumber(value).toFormat(decimalPlaces);

        // Rounding
        const round = (value, decimalPlaces = 0) =>
            new BigNumber(value).decimalPlaces(decimalPlaces).toString();

        // 将方法挂载到全局属性
        app.config.globalProperties.$bn = {
            add,
            subtract,
            multiply,
            divide,
            isGreaterThan,
            isLessThan,
            isEqualTo,
            format,
            round,
            // Expose BigNumber for advanced usage
            BigNumber
        };

        // 指令用于自动格式化 big numbers in inputs
        app.directive('bn-format', {
            mounted(el, binding) {
                const { decimals = 2 } = binding.value || {};

                el.addEventListener('blur', () => {
                    try {
                        const value = el.value;
                        if (value) {
                            const formatted = new BigNumber(value).toFormat(decimals);
                            el.value = formatted;

                            // Trigger input event for v-model
                            el.dispatchEvent(new Event('input'));
                        }
                    } catch (e) {
                        console.error('BigNumber formatting error:', e);
                    }
                });

                el.addEventListener('focus', () => {
                    try {
                        const value = el.value;
                        if (value) {
                            // Remove formatting for editing
                            const unformatted = new BigNumber(value.replace(/,/g, '')).toString();
                            el.value = unformatted;
                        }
                    } catch (e) {
                        console.error('BigNumber unformatting error:', e);
                    }
                });
            }
        });
    }
};

export default bigNumberPlugin;